// extracted by mini-css-extract-plugin
export var Contact = "style-module--Contact--2A4w5";
export var Description = "style-module--Description--1SIYR";
export var Profile = "style-module--Profile--2vGgB";
export var Avatar = "style-module--Avatar--26lt1";
export var ContactDetails = "style-module--ContactDetails--BOzte";
export var Name = "style-module--Name--A_LHl";